import React from "react"

function createMarkup(data: string) {
  return { __html: data }
}

export function buildHtmlFromString(data: string) {
  return <div dangerouslySetInnerHTML={createMarkup(data)} />
}
